import { render, staticRenderFns } from "./ReferralPoolProposeTimePage.vue?vue&type=template&id=0d1a8d10&scoped=true"
import script from "./ReferralPoolProposeTimePage.vue?vue&type=script&lang=js"
export * from "./ReferralPoolProposeTimePage.vue?vue&type=script&lang=js"
import style0 from "./ReferralPoolProposeTimePage.vue?vue&type=style&index=0&id=0d1a8d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1a8d10",
  null
  
)

export default component.exports